import { PlatformStatusChecks } from '@/store/budget/types'

export const PLATFORMS: { [key: string]: PlatformStatusChecks } = {
  fb: PlatformStatusChecks.facebook,
  tk: PlatformStatusChecks.tiktok,
}

export enum PlatformPrefixes {
  fb = 'fb',
  tg = 'tg',
  tk = 'tk',
  telegram_eur = 'telegram_eur',
  balance_usd = 'balance_usd',
  balance_eur = 'balance_eur',
}
